import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const xps = {
    jpath: ['spectra', 'xps'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default xps;
//# sourceMappingURL=xps.js.map